// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-text[data-v-2fe6aefe]{\r\n  font-size: 13px;\n}\r\n", ""]);
// Exports
module.exports = exports;
